<template>
    <div>
        <dx-grid
            url="foodWeeklyDistributions"
            :columns="columns"
            :title="title"
            :actions="actions"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            ref="grid"
        ></dx-grid>
        <v-dialog persistent v-model="createDistributionDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Create Distribution</v-card-title
                >
                <v-text-field
                    class="mb-0"
                    label="Distribution Name"
                    ref="createDistributionName"
                    :rules="[rules.required]"
                    v-model="newDistribution.distributionName"
                ></v-text-field>
                <v-text-field
                    class="mb-0"
                    label="Display Name"
                    ref="createDisplayName"
                    v-model="newDistribution.displayName"
                ></v-text-field>
                <v-menu
                    v-model="datePickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            class="mb-4"
                            hide-details
                            v-model="newDistribution.distributionStartDate"
                            :value="newDistribution.distributionStartDate"
                            label="Distribution Start Date"
                            prepend-icon="mdi-calendar"
                            ref="createDistributionStartDate"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="newDistribution.distributionStartDate"
                        :min="today"
                    ></v-date-picker>
                </v-menu>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="createDistributionDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveDistribution(newDistribution)"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="updateDistributionDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Distribution</v-card-title
                >
                <v-text-field
                    class="mb-0"
                    label="Distribution Name"
                    ref="distributionName"
                    :rules="[rules.required]"
                    v-model="distribution.distributionName"
                ></v-text-field>
                <v-text-field
                    class="mb-0"
                    label="Display Name"
                    ref="displayName"
                    v-model="distribution.displayName"
                ></v-text-field>
                <v-text-field
                    class="mb-0"
                    label="Sort"
                    type="number"
                    ref="sort"
                    v-model="distribution.sort"
                ></v-text-field>
                <v-menu
                    v-model="datePickerMenu2"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            class="mb-3"
                            hide-details
                            v-model="distribution.distributionStartDate"
                            :value="distribution.distributionStartDate"
                            label="Distribution Start Date"
                            prepend-icon="mdi-calendar"
                            ref="distributionStartDate"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="distribution.distributionStartDate"
                        :min="today"
                    ></v-date-picker>
                </v-menu>
                <v-checkbox
                    class="mb-3"
                    hide-details
                    label="Show Menu"
                    color="success"
                    v-model="distribution.showMenu"
                ></v-checkbox>
                <v-checkbox
                    class="mb-3"
                    hide-details
                    label="Completed"
                    color="success"
                    v-model="distribution.isCompleted"
                ></v-checkbox>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeUpdateDistribution"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveDistribution(distribution)"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            persistent
            v-model="updateActiveDistributionDialog"
            max-width="400"
        >
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Distribution Settings</v-card-title
                >
                <v-select
                    class="mb-2"
                    label="Active Distribution"
                    :items="distributions.map((d) => d.distributionName)"
                    v-model="activeDistribution"
                    ref="activeDistribution"
                    clearable
                ></v-select>
                <v-select
                    class="mb-2"
                    label="Default Distribution"
                    :items="distributions.map((d) => d.distributionName)"
                    v-model="defaultDistribution"
                    ref="defaultDistribution"
                    clearable
                ></v-select>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateActiveDistributionDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="updateActiveDistribution"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div></template
>
<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Distributions",
        columns: [
            {
                label: "Name",
                field: "distributionName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Display Name",
                field: "displayName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Created",
                field: "dateCreated",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Start Date",
                field: "distributionStartDate",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Completed",
                field: "isCompleted",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Show Menu",
                field: "showMenu",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Sort",
                field: "sort",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        actions: [],
        url: "",
        user: "",
        processing: false,
        datePickerMenu: false,
        datePickerMenu2: false,
        createDistributionDialog: false,
        updateDistributionDialog: false,
        updateActiveDistributionDialog: false,

        today: moment().format("YYYY-MM-DD HH:mm:ss"),

        distribution: "",
        activeDistribution: "",
        defaultDistribution: "",
        distributions: [],

        newDistribution: {
            distributionName: "",
            displayName: "",
            distributionStartDate: "",
            dateCreated: "",
            isCompleted: false,
        },

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },
    }),
    created() {
        this.user = this.$store.state.authentication.user;

        this.actions.push({
            text: "Distribution Settings",
            action: this.openActiveDistributionDialog,
        });

        this.actions.push({
            text: "Create Distribution",
            action: this.createDistribution,
        });

        this.loadDistributions();
    },
    mounted() {},
    methods: {
        onRowClicked(row) {
            this.distribution = row;
            this.updateDistributionDialog = true;
        },
        async openActiveDistributionDialog() {
            const response = await this.$http.get(
                "api/foodWeeklyDistributions/getDistributionSettings"
            );
            this.activeDistribution = response.activeDistributionSetting;
            this.defaultDistribution = response.defaultDistributionSetting;

            this.updateActiveDistributionDialog = true;
        },
        async loadDistributions() {
            const response = await this.$http.get(
                "odata/foodWeeklyDistributions?$filter=not (isCompleted eq true)"
            );

            this.distributions = response.value;
        },
        createDistribution() {
            this.createDistributionDialog = true;
        },
        closeUpdateDistribution() {
            this.updateDistributionDialog = false;

            this.$refs.grid.reloadGrid();
        },
        async saveDistribution(distribution) {
            if (distribution.distributionID) {
                if (!this.$refs.distributionName.validate(true)) return;
            } else {
                if (!this.$refs.createDistributionName.validate(true)) return;
            }

            if (!distribution.distributionID) {
                distribution.dateCreated = moment().format(
                    "YYYY-MM-DD HH:mm:ss"
                );
            }

            try {
                await this.$http.post(
                    "api/foodWeeklyDistributions/save",
                    distribution
                );

                this.createDistributionDialog = false;
                this.updateDistributionDialog = false;

                this.$refs.grid.reloadGrid();
                this.loadDistributions();
            } catch (e) {}
        },
        async updateActiveDistribution(distribution) {
            try {
                await this.$http.post(
                    "api/foodWeeklyDistributions/updateActiveDistribution?activeDistribution=" +
                        (this.activeDistribution
                            ? this.activeDistribution
                            : "") +
                        "&defaultDistribution=" +
                        (this.defaultDistribution
                            ? this.defaultDistribution
                            : "")
                );

                this.updateActiveDistributionDialog = false;
            } catch (e) {}
        },
    },
};
</script>
